/* Action types with TypeScript type declaration */

export const SET_INVOICES_IS_PENDING =
  'rpb2b-react/invoices/SET_INVOICES_IS_PENDING';
export type SET_INVOICES_IS_PENDING = typeof SET_INVOICES_IS_PENDING;

export const SET_INVOICES_ERROR = 'rpb2b-react/invoices/SET_INVOICES_ERROR';
export type SET_INVOICES_ERROR = typeof SET_INVOICES_ERROR;

export const SET_INVOICES_SUCCESS = 'rpb2b-react/invoices/SET_INVOICES_SUCCESS';
export type SET_INVOICES_SUCCESS = typeof SET_INVOICES_SUCCESS;

export const SET_MANUAL_INVOICES_ERROR =
  'rpb2b-react/invoices/SET_MANUAL_INVOICES_ERROR';
export type SET_MANUAL_INVOICES_ERROR = typeof SET_MANUAL_INVOICES_ERROR;

export const SET_MANUAL_INVOICES_SUCCESS =
  'rpb2b-react/invoices/SET_MANUAL_INVOICES_SUCCESS';
export type SET_MANUAL_INVOICES_SUCCESS = typeof SET_MANUAL_INVOICES_SUCCESS;

export const SET_INVOICES_DATA = 'rpb2b-react/invoices/SET_INVOICES_DATA';
export type SET_INVOICES_DATA = typeof SET_INVOICES_DATA;

export const SET_ORIGINAL_INVOICES =
  'rpb2b-react/invoices/SET_ORIGINAL_INVOICES';
export type SET_ORIGINAL_INVOICES = typeof SET_ORIGINAL_INVOICES;

export const SET_OLDEST_INVOICES = 'rpb2b-react/invoices/SET_OLDEST_INVOICES';
export type SET_OLDEST_INVOICES = typeof SET_OLDEST_INVOICES;

export const SET_INVOICES_DATE_RANGE_FILTER =
  'rpb2b-react/invoices/SET_INVOICES_DATE_RANGE_FILTER';
export type SET_INVOICES_DATE_RANGE_FILTER = typeof SET_INVOICES_DATE_RANGE_FILTER;

export const SET_INVOICES_SORT_FILTER =
  'rpb2b-react/invoices/SET_INVOICES_SORT_FILTER';
export type SET_INVOICES_SORT_FILTER = typeof SET_INVOICES_SORT_FILTER;

export const SET_INVOICES_STATUS_FILTER =
  'rpb2b-react/invoices/SET_INVOICES_STATUS_FILTER';
export type SET_INVOICES_STATUS_FILTER = typeof SET_INVOICES_STATUS_FILTER;

export const SET_INVOICES_ORDER_STATUS_FILTER =
  'rpb2b-react/invoices/SET_INVOICES_ORDER_STATUS_FILTER';
export type SET_INVOICES_ORDER_STATUS_FILTER = typeof SET_INVOICES_ORDER_STATUS_FILTER;

export const SET_INVOICES_INVOICE_FILTER =
  'rpb2b-react/invoices/SET_INVOICES_INVOICE_FILTER';
export type SET_INVOICES_SEARCH_FILTER = typeof SET_INVOICES_INVOICE_FILTER;

export const SET_INVOICES_NARD_FILTER =
  'rpb2b-react/invoices/SET_INVOICES_NARD_FILTER';
export type SET_INVOICES_NARD_FILTER = typeof SET_INVOICES_NARD_FILTER;

export const SET_INVOICES_ORDER_FILTER =
  'rpb2b-react/invoices/SET_INVOICES_ORDER_FILTER';
export type SET_INVOICES_ORDER_FILTER = typeof SET_INVOICES_ORDER_FILTER;

export const SET_INVOICES_PO_FILTER =
  'rpb2b-react/invoices/SET_INVOICES_PO_FILTER';
export type SET_INVOICES_PO_FILTER = typeof SET_INVOICES_PO_FILTER;

export const SET_INVOICES_PAGE_NUMBER =
  'rpb2b-react/invoices/SET_INVOICES_PAGE_NUMBER';
export type SET_INVOICES_PAGE_NUMBER = typeof SET_INVOICES_PAGE_NUMBER;

export const SET_INVOICES_PAGE_SIZE =
  'rpb2b-react/invoices/SET_INVOICES_PAGE_SIZE';
export type SET_INVOICES_PAGE_SIZE = typeof SET_INVOICES_PAGE_SIZE;

export const SET_INVOICES_TOTAL_ELEMENTS =
  'rpb2b-react/invoices/SET_INVOICES_TOTAL_ELEMENTS';
export type SET_INVOICES_TOTAL_ELEMENTS = typeof SET_INVOICES_TOTAL_ELEMENTS;

export const SET_CREDIT_INVOICES_TOTAL_ELEMENTS =
  'rpb2b-react/invoices/SET_CREDIT_INVOICES_TOTAL_ELEMENTS';
export type SET_CREDIT_INVOICES_TOTAL_ELEMENTS = typeof SET_CREDIT_INVOICES_TOTAL_ELEMENTS;

export const SET_INVOICES_TOTAL_PAGES =
  'rpb2b-react/invoice/SET_INVOICES_TOTAL_PAGES';
export type SET_INVOICES_TOTAL_PAGES = typeof SET_INVOICES_TOTAL_PAGES;

export const SET_SELECTED_INVOICES =
  'rpb2b-react/invoice/SET_SELECTED_INVOICES';
export type SET_SELECTED_INVOICES = typeof SET_SELECTED_INVOICES;

export const SET_SELECTED_CREDIT_INVOICES =
  'rpb2b-react/invoice/SET_SELECTED_CREDIT_INVOICES';
export type SET_SELECTED_CREDIT_INVOICES = typeof SET_SELECTED_CREDIT_INVOICES;

export const SET_IS_INVOICE_ACTIVE =
  'rpb2b-react/invoice/SET_IS_INVOICE_ACTIVE';
export type SET_IS_INVOICE_ACTIVE = typeof SET_IS_INVOICE_ACTIVE;

export const SET_INVOICES_CREDIT =
  'rpb2b-react/invoices/SET_OLDEST_INVOICES_CREDIT';
export type SET_INVOICES_CREDIT = typeof SET_INVOICES_CREDIT;

export const SET_INVOICES_DEBIT = 'rpb2b-react/invoices/SET_INVOICES_DEBIT';
export type SET_INVOICES_DEBIT = typeof SET_INVOICES_DEBIT;

export const SET_OLDEST_INVOICES_CREDIT =
  'rpb2b-react/invoices/SET_OLDEST_INVOICES_CREDIT';
export type SET_OLDEST_INVOICES_CREDIT = typeof SET_OLDEST_INVOICES_CREDIT;

export const SET_OLDEST_INVOICES_DEBIT =
  'rpb2b-react/invoices/SET_OLDEST_INVOICES_DEBIT';
export type SET_OLDEST_INVOICES_DEBIT = typeof SET_OLDEST_INVOICES_DEBIT;

export const SET_CREDIT_INVOICES_CREDIT =
  'rpb2b-react/invoices/SET_CREDIT_INVOICES_CREDIT';
export type SET_CREDIT_INVOICES_CREDIT = typeof SET_CREDIT_INVOICES_CREDIT;

export const SET_CREDIT_INVOICES_DEBIT =
  'rpb2b-react/invoices/SET_CREDIT_INVOICES_DEBIT';
export type SET_CREDIT_INVOICES_DEBIT = typeof SET_CREDIT_INVOICES_DEBIT;

export const SET_ORIGINAL_INVOICES_CREDIT =
  'rpb2b-react/invoices/SET_ORIGINAL_INVOICES_CREDIT';
export type SET_ORIGINAL_INVOICES_CREDIT = typeof SET_ORIGINAL_INVOICES_CREDIT;

export const SET_ORIGINAL_INVOICES_DEBIT =
  'rpb2b-react/invoices/SET_ORIGINAL_INVOICES_DEBIT';
export type SET_ORIGINAL_INVOICES_DEBIT = typeof SET_ORIGINAL_INVOICES_DEBIT;

export const SET_CREDIT_INVOICES = 'rpb2b-react/invoices/SET_CREDIT_INVOICES';
export type SET_CREDIT_INVOICES = typeof SET_CREDIT_INVOICES;

export default {
  SET_INVOICES_IS_PENDING,
  SET_INVOICES_ERROR,
  SET_INVOICES_SUCCESS,
  SET_INVOICES_DATA,
  SET_ORIGINAL_INVOICES,
  SET_OLDEST_INVOICES,
  SET_INVOICES_DATE_RANGE_FILTER,
  SET_INVOICES_SORT_FILTER,
  SET_INVOICES_STATUS_FILTER,
  SET_INVOICES_ORDER_STATUS_FILTER,
  SET_INVOICES_INVOICE_FILTER,
  SET_INVOICES_NARD_FILTER,
  SET_INVOICES_ORDER_FILTER,
  SET_INVOICES_PO_FILTER,
  SET_INVOICES_PAGE_NUMBER,
  SET_INVOICES_PAGE_SIZE,
  SET_INVOICES_TOTAL_ELEMENTS,
  SET_INVOICES_TOTAL_PAGES,
  SET_SELECTED_INVOICES,
  SET_SELECTED_CREDIT_INVOICES,
  SET_IS_INVOICE_ACTIVE,
  SET_OLDEST_INVOICES_DEBIT,
  SET_OLDEST_INVOICES_CREDIT,
  SET_ORIGINAL_INVOICES_CREDIT,
  SET_ORIGINAL_INVOICES_DEBIT,
  SET_INVOICES_CREDIT,
  SET_INVOICES_DEBIT,
  SET_CREDIT_INVOICES,
  SET_CREDIT_INVOICES_CREDIT,
  SET_MANUAL_INVOICES_ERROR,
  SET_MANUAL_INVOICES_SUCCESS,
  SET_CREDIT_INVOICES_DEBIT,
  SET_CREDIT_INVOICES_TOTAL_ELEMENTS
};
